// Frontend module field schemas — shape forms + list columns
// type: "text" | "textarea" | "date" | "number" | "select" | "boolean"

export const MODULE_SCHEMAS = {
  family: {
    label: "Family & Dependents",
    icon: "Users",
    list_columns: ["relation", "mobile", "blood_group"],
    fields: [
      { key: "relation", label: "Relation", type: "select",
        options: ["Spouse", "Son", "Daughter", "Father", "Mother", "Brother", "Sister", "Guardian", "Other"] },
      { key: "date_of_birth", label: "Date of Birth", type: "date" },
      { key: "blood_group", label: "Blood Group", type: "select",
        options: ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"] },
      { key: "mobile", label: "Mobile" },
      { key: "email", label: "Email" },
      { key: "address", label: "Address", type: "textarea" },
      { key: "dependent_status", label: "Dependent Status" },
      { key: "guardian_details", label: "Guardian Details" },
    ],
  },
  contacts: {
    label: "Important Contacts",
    icon: "Phone",
    list_columns: ["category", "phone", "priority"],
    fields: [
      { key: "category", label: "Category", type: "select",
        options: ["Spouse", "Parent", "Child", "Sibling", "Close Friend", "Family Doctor",
          "Chartered Accountant", "Lawyer", "Financial Advisor", "Insurance Advisor",
          "Employer HR", "Broker / RM", "Property Consultant", "Other"] },
      { key: "phone", label: "Phone" },
      { key: "email", label: "Email" },
      { key: "address", label: "Address", type: "textarea" },
      { key: "priority", label: "Priority", type: "select", options: ["High", "Medium", "Low"] },
    ],
  },
  "bank-accounts": {
    label: "Bank Accounts",
    icon: "Landmark",
    list_columns: ["bank_name", "account_number", "account_type", "purpose_tag"],
    sensitive: ["account_number"],
    fields: [
      { key: "bank_name", label: "Bank Name" },
      { key: "branch", label: "Branch" },
      { key: "account_number", label: "Account Number", sensitive: true },
      { key: "ifsc", label: "IFSC" },
      { key: "account_type", label: "Type", type: "select",
        options: ["Savings", "Savings (Salary)", "Current", "NRE", "NRO", "FCNR"] },
      { key: "joint_holder", label: "Joint Holder" },
      { key: "nominee", label: "Nominee" },
      { key: "nominee_relationship", label: "Nominee Relationship" },
      { key: "nominee_verified", label: "Nominee Verified", type: "boolean" },
      { key: "registered_mobile", label: "Registered Mobile" },
      { key: "registered_email", label: "Registered Email" },
      { key: "internet_banking_active", label: "Internet Banking",
        type: "select", options: ["Yes", "No"] },
      { key: "purpose_tag", label: "Purpose Tag",
        type: "select", options: ["Salary", "Emergency", "Family", "Business", "Savings", "Other"] },
      { key: "status", label: "Status", type: "select", options: ["Active", "Inactive", "Closed"] },
      { key: "balance", label: "Approx. Balance (₹)", type: "number" },
      { key: "document_location", label: "Document Location" },
    ],
  },
  investments: {
    label: "Investments",
    icon: "TrendingUp",
    list_columns: ["investment_type", "platform", "current_value"],
    sensitive: ["folio_number", "demat_number"],
    fields: [
      { key: "investment_type", label: "Investment Type", type: "select",
        options: ["Mutual Fund", "Stocks / Demat", "ETF", "Fixed Deposit", "Recurring Deposit",
          "Bonds", "Sovereign Gold Bond", "Physical Gold", "PPF", "EPF", "VPF", "NPS", "SSY",
          "PMS / AIF", "ULIP", "Crypto", "Real Estate", "Business Ownership", "ESOP / RSU"] },
      { key: "platform", label: "Platform / Institution" },
      { key: "folio_number", label: "Folio Number", sensitive: true },
      { key: "demat_number", label: "Demat/Client Code", sensitive: true },
      { key: "account_holder", label: "Account Holder" },
      { key: "nominee", label: "Nominee" },
      { key: "nominee_relationship", label: "Nominee Relationship" },
      { key: "nominee_verified", label: "Nominee Verified", type: "boolean" },
      { key: "advisor", label: "Advisor / RM" },
      { key: "linked_bank", label: "Linked Bank Account" },
      { key: "linked_mobile", label: "Linked Mobile" },
      { key: "linked_email", label: "Linked Email" },
      { key: "maturity_date", label: "Maturity Date", type: "date" },
      { key: "invested_amount", label: "Invested Amount (₹)", type: "number" },
      { key: "current_value", label: "Current Value (₹)", type: "number" },
      { key: "holding_location", label: "Holding Location" },
    ],
  },
  insurance: {
    label: "Insurance",
    icon: "Shield",
    list_columns: ["insurer", "policy_type", "premium_due_date"],
    sensitive: ["policy_number"],
    fields: [
      { key: "policy_type", label: "Policy Type", type: "select",
        options: ["Term Life", "Endowment Life", "ULIP", "Health", "Personal Accident",
          "Critical Illness", "Car", "Home", "Travel", "Other"] },
      { key: "insurer", label: "Insurer" },
      { key: "policy_number", label: "Policy Number", sensitive: true },
      { key: "covered_person", label: "Covered Person(s)" },
      { key: "sum_insured", label: "Sum Insured (₹)", type: "number" },
      { key: "nominee", label: "Nominee" },
      { key: "nominee_relationship", label: "Nominee Relationship" },
      { key: "nominee_verified", label: "Nominee Verified", type: "boolean" },
      { key: "premium_amount", label: "Premium Amount (₹)", type: "number" },
      { key: "premium_due_date", label: "Premium Due Date", type: "date" },
      { key: "validity_date", label: "Valid Till", type: "date" },
      { key: "advisor", label: "Advisor" },
      { key: "claim_helpline", label: "Claim Helpline" },
      { key: "claim_process_notes", label: "Claim Process Notes", type: "textarea" },
    ],
  },
  cards: {
    label: "Cards",
    icon: "CreditCard",
    list_columns: ["card_type", "issuing_bank", "card_number", "status"],
    sensitive: ["card_number"],
    fields: [
      { key: "card_type", label: "Card Type", type: "select", options: ["Debit", "Credit"] },
      { key: "issuing_bank", label: "Issuing Bank" },
      { key: "cardholder_name", label: "Cardholder Name" },
      { key: "card_number", label: "Card Number (masked)", sensitive: true },
      { key: "linked_account", label: "Linked Account" },
      { key: "registered_mobile", label: "Registered Mobile" },
      { key: "valid_till", label: "Valid Till" },
      { key: "card_network", label: "Network",
        type: "select", options: ["Visa", "Mastercard", "RuPay", "Amex", "Diners", "Other"] },
      { key: "status", label: "Status", type: "select", options: ["Active", "Blocked", "Expired"] },
    ],
  },
  property: {
    label: "Property & Physical Assets",
    icon: "Home",
    list_columns: ["asset_type", "owner_names", "current_estimate"],
    sensitive: ["registration_number"],
    fields: [
      { key: "asset_type", label: "Asset Type", type: "select",
        options: ["Residential Property", "Commercial Property", "Land", "Vehicle",
          "Jewellery / Valuables", "Other"] },
      { key: "asset_name", label: "Asset Name / Address" },
      { key: "owner_names", label: "Owner Name(s)" },
      { key: "registration_number", label: "Registration Number", sensitive: true },
      { key: "purchase_date", label: "Purchase Date", type: "date" },
      { key: "purchase_value", label: "Purchase Value (₹)", type: "number" },
      { key: "current_estimate", label: "Current Estimate (₹)", type: "number" },
      { key: "nominee", label: "Nominee / Successor Note" },
      { key: "physical_location", label: "Physical Location" },
      { key: "document_location", label: "Document Location" },
    ],
  },
  lockers: {
    label: "Locker Details",
    icon: "Lock",
    list_columns: ["bank", "branch", "held_in_name"],
    sensitive: ["locker_number"],
    fields: [
      { key: "bank", label: "Bank / Institution" },
      { key: "branch", label: "Branch" },
      { key: "linked_account_number", label: "Linked Account", sensitive: true },
      { key: "locker_number", label: "Locker Number", sensitive: true },
      { key: "held_in_name", label: "Held In Name" },
      { key: "nominee", label: "Nominee" },
      { key: "key_location", label: "Key Location" },
      { key: "access_instructions", label: "Access Instructions", type: "textarea" },
    ],
  },
  liabilities: {
    label: "Liabilities",
    icon: "TrendingDown",
    list_columns: ["lender", "liability_type", "loan_account_number", "outstanding_amount"],
    sensitive: ["loan_account_number"],
    fields: [
      { key: "lender", label: "Lender" },
      { key: "liability_type", label: "Liability Type", type: "select",
        options: ["Home Loan", "Personal Loan", "Car Loan", "Loan Against Property",
          "Business Loan", "Education Loan", "Credit Card Dues", "Informal Loan"] },
      { key: "loan_account_number", label: "Loan Account Number", sensitive: true },
      { key: "original_amount", label: "Original Amount (₹)", type: "number" },
      { key: "outstanding_amount", label: "Outstanding (₹)", type: "number" },
      { key: "emi", label: "EMI (₹)", type: "number" },
      { key: "due_date", label: "Next Due Date", type: "date" },
      { key: "tenure_months", label: "Tenure (months)", type: "number" },
      { key: "insurance_linked", label: "Insurance Linked", type: "select", options: ["Yes", "No"] },
      { key: "co_borrower", label: "Co-borrower" },
      { key: "closure_process", label: "Closure Process Notes", type: "textarea" },
    ],
  },
  documents: {
    label: "Important Documents",
    icon: "FileText",
    list_columns: ["category", "holder_name", "document_number", "expiry_date"],
    sensitive: ["document_number"],
    fields: [
      { key: "category", label: "Category", type: "select",
        options: ["PAN", "Aadhaar", "Passport", "Driving Licence", "Voter ID",
          "Marriage Certificate", "Birth Certificate", "Will", "Trust Deed",
          "Power of Attorney", "Property Papers", "Insurance Policy",
          "Loan Document", "Cheque Book", "Tax Return", "Investment Statement",
          "Mediclaim Card", "School Record", "Other"] },
      { key: "holder_name", label: "Holder Name" },
      { key: "document_number", label: "Document Number", sensitive: true },
      { key: "issue_date", label: "Issue Date", type: "date" },
      { key: "expiry_date", label: "Expiry Date", type: "date" },
      { key: "physical_location", label: "Physical Location" },
      { key: "digital_location", label: "Digital Location" },
    ],
  },
  "tax-compliance": {
    label: "Tax & Compliance",
    icon: "Receipt",
    list_columns: ["pan", "ca_details", "last_filed_year"],
    sensitive: ["pan", "aadhaar"],
    fields: [
      { key: "pan", label: "PAN", sensitive: true },
      { key: "aadhaar", label: "Aadhaar", sensitive: true },
      { key: "aadhaar_linked", label: "Aadhaar-PAN Linked",
        type: "select", options: ["Yes", "No", "Not sure"] },
      { key: "tax_login_instructions", label: "Tax Login Instructions", type: "textarea" },
      { key: "ais_tis_details", label: "AIS / TIS Details", type: "textarea" },
      { key: "ca_details", label: "CA Details" },
      { key: "gst_details", label: "GST Details" },
      { key: "due_dates", label: "Due Dates" },
      { key: "last_filed_year", label: "Last Filed Year" },
      { key: "last_filed_date", label: "Last Filed Date", type: "date" },
      { key: "tax_folder_location", label: "Tax Folder Location" },
    ],
  },
  "employer-benefits": {
    label: "Employer & Retirement Benefits",
    icon: "Briefcase",
    list_columns: ["employer_name", "employee_id"],
    sensitive: ["epf_uan", "employee_id"],
    fields: [
      { key: "employer_name", label: "Employer Name" },
      { key: "employee_id", label: "Employee ID", sensitive: true },
      { key: "hr_contact", label: "HR Contact" },
      { key: "epf_uan", label: "EPF UAN", sensitive: true },
      { key: "gratuity_status", label: "Gratuity Status" },
      { key: "superannuation_details", label: "Superannuation Details" },
      { key: "nps_details", label: "NPS Details" },
      { key: "group_insurance_details", label: "Group Insurance" },
      { key: "esop_rsu_details", label: "ESOP / RSU Details", type: "textarea" },
      { key: "final_settlement_process", label: "F&F Settlement Process", type: "textarea" },
    ],
  },
  income: {
    label: "Income Sources",
    icon: "IndianRupee",
    list_columns: ["income_source", "amount", "frequency"],
    fields: [
      { key: "income_source", label: "Income Source", type: "select",
        options: ["Salary", "Business", "Rental", "Freelance", "Dividends", "Pension",
          "Royalty / Commission", "Other"] },
      { key: "amount", label: "Amount (₹)", type: "number" },
      { key: "frequency", label: "Frequency",
        type: "select", options: ["Monthly", "Quarterly", "Half-yearly", "Annually", "Adhoc"] },
      { key: "receiving_account", label: "Receiving Account" },
      { key: "contact_person", label: "Contact Person" },
      { key: "continuity_instructions", label: "Continuity Instructions", type: "textarea" },
    ],
  },
  recurring: {
    label: "Recurring Expenses",
    icon: "RefreshCw",
    list_columns: ["category", "vendor", "amount"],
    fields: [
      { key: "category", label: "Category", type: "select",
        options: ["EMI", "SIP", "Rent", "School Fees", "Electricity", "Water",
          "Internet", "Gas", "Maid Salary", "Subscription", "Society Maintenance",
          "Insurance Premium", "Other"] },
      { key: "vendor", label: "Vendor / Payee" },
      { key: "amount", label: "Amount (₹)", type: "number" },
      { key: "due_date", label: "Next Due Date", type: "date" },
      { key: "payment_mode", label: "Payment Mode" },
      { key: "linked_account", label: "Linked Account" },
      { key: "auto_debit", label: "Auto-debit", type: "select", options: ["Yes", "No"] },
      { key: "must_continue", label: "Must Continue", type: "select", options: ["Yes", "No"] },
      { key: "can_be_stopped", label: "Can Be Stopped", type: "select", options: ["Yes", "No"] },
    ],
  },
  "digital-assets": {
    label: "Digital Assets & Access",
    icon: "KeyRound",
    list_columns: ["platform", "owner", "registered_email"],
    sensitive: ["registered_email", "registered_mobile"],
    fields: [
      { key: "platform", label: "Platform / Account" },
      { key: "owner", label: "Owner" },
      { key: "registered_email", label: "Registered Email", sensitive: true },
      { key: "registered_mobile", label: "Registered Mobile", sensitive: true },
      { key: "recovery_contact", label: "Recovery Contact" },
      { key: "access_instruction", label: "Access Instruction (no raw passwords)", type: "textarea" },
      { key: "emergency_note", label: "Emergency Note", type: "textarea" },
    ],
  },
  "claim-tracker": {
    label: "Claim & Closure Tracker",
    icon: "ClipboardCheck",
    list_columns: ["item_type", "institution", "claim_status"],
    fields: [
      { key: "item_type", label: "Item Type", type: "select",
        options: ["Bank Claim", "Insurance Claim", "Investment Transmission",
          "Demat Transmission", "EPF Claim", "Property Transmission",
          "Locker Access", "Tax Closure", "Other"] },
      { key: "institution", label: "Institution" },
      { key: "claim_status", label: "Status", type: "select",
        options: ["Not started", "Documents pending", "Submitted", "Under review", "Approved", "Paid/Closed"] },
      { key: "assigned_person", label: "Assigned Person" },
      { key: "pending_documents", label: "Pending Documents", type: "textarea" },
      { key: "expected_timeline", label: "Expected Timeline" },
    ],
  },
};

export const MODULE_ORDER = [
  "family", "contacts", "bank-accounts", "investments", "insurance",
  "cards", "property", "lockers", "liabilities", "documents",
  "tax-compliance", "employer-benefits", "income", "recurring",
  "digital-assets", "claim-tracker",
];
